import ModalSelection from '@storefront/shared-components/modals/modal-selection/modal-selection';

import SingleTriggerVisibleEvent, {
  SingleTriggerVisibleEventProps,
} from '../../../../analytics/SingleTriggerVisibleEvent';

export interface ModalSelectionAnalyticsProps
  extends SingleTriggerVisibleEventProps {
  modalName: string;
}

const ModalSelectionAnalytics = (props: ModalSelectionAnalyticsProps) => {
  const { modalName } = props;
  return (
    <div id="printer-modal-container">
      <ModalSelection modalName={modalName} />
    </div>
  );
};

export default SingleTriggerVisibleEvent(ModalSelectionAnalytics);
